import { render, staticRenderFns } from "./OrdenacaoNivelMenu.vue?vue&type=template&id=40fa43ea"
import script from "./OrdenacaoNivelMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdenacaoNivelMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports